import TitleItem from "./titleItem";

export default class IconTitleItem extends TitleItem {
    icon: string;

    constructor(title: string, description: string, icon: string) {
        super(title, description);
        this.icon = icon;
    }
}